import React from 'react';
import activeLogo from "../../../assets/img/active.svg";

import { Card, Grid, Text, Badge, Box, Flex, createStyles } from '@mantine/core';
const useStyles = createStyles(() => ({
    default: {
      borderRadius: "8px",
      marginLeft: "40px",
      marginRight: "40px",
      padding: "16px",
      marginTop: "16px",
    },
    
    downloadLoader: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      backdropFilter: "blur(0.5px)",
      zIndex: 9999,
    },box1:{
        display:"flex",
        flexDirection:"column",
        backgroundColor:"white",
        padding:"16px"
    },
    dataBox: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
      },

  }));
  
interface InsuranceInfoProps {
    eligibilityDetails:any
}
const InsuranceInfo: React.FC<InsuranceInfoProps> = ({
    eligibilityDetails
}) => {
    const { classes } = useStyles();

  return (
    <Flex sx={{ width: "100%" }}>
    <Grid grow sx={{ width: "100%" }}>
      {eligibilityDetails.map((data:any, index:any) => (
        <Grid.Col span={4}>
          <Flex
            bg={"#f5fbff"}
            direction={"column"}
            sx={{
              height: "90px",
              border:
                data.title === "Status" && data.data === "active"
                  ? "1px solid #2C9D08"
                  : "none",
              backgroundColor:
                data.title === "Status" && data.data === "active"
                  ? "#efffef"
                  : "#F1F9FF",
              borderRadius: "4px",
            }}
            justify={"space-evenly"}
          >
            <Text
              align={"center"}
              size={14}
              weight={500}
              color={"#474E5B"}
            >
              {data.title}
            </Text>
            <Box className={classes.dataBox}>
              {" "}
              {data.title === "Status" &&
                data.data === "active" && (
                  <img
                    src={activeLogo}
                    alt="check"
                    style={{ paddingRight: "5px", width: "20px" }}
                  />
                )}
              <Text
                size={14}
                weight={700}
                color={
                  data.title === "Status" &&
                  data.data === "active"
                    ? "#2C9D08"
                    : "#262930"
                }
                tt={"uppercase"}
              >
                {" "}
                {data.data}
              </Text>
            </Box>
          </Flex>
        </Grid.Col>
      ))}
    </Grid>
  </Flex>  );
};

export default InsuranceInfo;
